import SiafLiteApiRepository from "../../external/siafLiteApi";

class AgendamentoServicosService {
  constructor() {
    this.urlBase = "/estoque/agendamento-servicos";
    this.urlBaseEvent = `/event${this.urlBase}`;
  }

  getById(id) {
    return new SiafLiteApiRepository(this.urlBaseEvent).getById(id);
  }

  getAll(filter) {
    return new SiafLiteApiRepository(this.urlBaseEvent).get(filter);
  }

  getAllAgendamentosTotalMes(body) {
    return new SiafLiteApiRepository(`${this.urlBaseEvent}/total-mes`).patch(
      body,
    );
  }

  getAllAgendamentosDia(body) {
    return new SiafLiteApiRepository(`${this.urlBaseEvent}/total-dia`).patch(
      body,
    );
  }

  cadastrar(body) {
    return new SiafLiteApiRepository(this.urlBaseEvent).post(body);
  }

  atualizar(id, body) {
    return new SiafLiteApiRepository(this.urlBaseEvent).put(id, body);
  }

  deletar(id) {
    return new SiafLiteApiRepository(this.urlBaseEvent).delete(id);
  }

  getAllFiltroAvancado(body) {
    return new SiafLiteApiRepository(this.urlBaseEvent).patch(body);
  }
}

export default AgendamentoServicosService;
